export const albums = {
  Items: [
    {
      key: 1,
      name: "OneStep",
      img: "/img/toneside_Square_buggy01.jpg",
      songs: [{ key: 1, name: "", bandcampLink: "" }],
    },
  ],
  getAlbums: () => albums.Items,
};
